import { createContext, useContext } from 'react';
import { AnyRecord, EmptyResponse } from '@ssar-app/domain';

export type ProgramSubmitState = 'Init' | 'Force' | 'ForceContinue';

export type ProgramDependentDataContextState = {
  data: EmptyResponse;
  metaData?: AnyRecord;
  setMetaData: (metaData: AnyRecord) => void;
  updateWarnings: boolean;
  setUpdateWarnings: (updateWarnings: boolean) => void;
  forceSubmitState: ProgramSubmitState;
  setForceSubmitState: (forceState: ProgramSubmitState) => void;
};

export const defaultProgramDependentContextValues: ProgramDependentDataContextState =
  {
    data: {},
    metaData: {},
    setMetaData: (_data: AnyRecord) => {
      // Do nothing
    },
    updateWarnings: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setUpdateWarnings: (_updateWarnings: boolean) => {},
    forceSubmitState: 'Init',
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setForceSubmitState: (_forceState: ProgramSubmitState) => {},
  };

const ProgramDependentDataContext =
  createContext<ProgramDependentDataContextState>(
    defaultProgramDependentContextValues,
  );

export const ProgramDependentDataProvider =
  ProgramDependentDataContext.Provider;

export const useProgramDependentDataContext =
  (): ProgramDependentDataContextState =>
    useContext(ProgramDependentDataContext);
